import MaintenanceManagementDialog
  from "@/views/settings/maintenanceManagement/maintenanceManagementDialog/MaintenanceManagementDialog.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import {MaintenanceMixin} from "@/mixins/Maintenance";

export default {
  name: "MaintenanceManagement",
  mixins: [MaintenanceMixin],
  components: {
    ConfirmDlg,
    MaintenanceManagementDialog
  },
  data() {
    return {
      search: "",
      loading: true,
      headers: [
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Category'],
          align: "start",
          value: "category",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Department'],
          align: "start",
          value: "department",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Icon'],
          align: "start",
          value: "icon",
          sortable: false
        },
        {
          align: "end",
          value: "id",
          sortable: false
        }
      ]
    }
  },
  async created() {
    await this.$store.dispatch("getMaintenanceTypes");
    this.loading = false;
  },
  computed: {
    maintenanceTypes() {
      return this.$store.state.maintenanceModule.maintenanceTypes;
    }
  },
  methods: {
    openDialogMaintenance() {
      this.$refs.maintenanceManagementDialog.open(null, "add");
    },
    updateMaintenanceType(maintenance) {
      this.$refs.maintenanceManagementDialog.open(maintenance, "update");
    },
    deleteMaintenanceType(item) {
      this.$refs.ConfirmDlg
        .open(null, this.$i18n.messages[this.$i18n.locale]['MaintenanceManagement.DeleteMaintenanceType'].replace('[name]',item.name), false, '', { noButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Cancel'], yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Delete'] })
        .then(async response => {
          if (response && response.agree) {
            await this.$store.dispatch("deleteMaintenanceType", item).then(async () => {
              this.$toast.open({
                message: this.$i18n.messages[this.$i18n.locale]['LocationManagement.LocationSuccessfullyDeleted'],
                type: "success"
              });
            })
          }
        });
    }
  }
}